import React from "react";
import Image from "next/image";

const StatsMilesMobile = () => {
  //   // State to track hover on each card

  return (
    <>
      {/* Mobile Version */}
      <div className="w-full px-6 justify-center relative bg-center square_grid_bg bg-repeat bg-[length:100% 100%] md:hidden block">
        <Image
          priority
          src="/about-us/photos-grid-team-mobile-short.png"
          alt="Accoun"
          className="w-full"
          width={312}
          height={625}
        />
      </div>
    </>
  );
};

export default StatsMilesMobile;
